import { AIInsights as AntdAIInsights } from "@empglabs/backoffice-ui-kit"

export const AIInsights = props => {
  return <AntdAIInsights {...props} />
}
